import { render, staticRenderFns } from "./TvSidePanel.vue?vue&type=template&id=7c7fcc6b&scoped=true&"
import script from "./TvSidePanel.vue?vue&type=script&lang=js&"
export * from "./TvSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./TvSidePanel.vue?vue&type=style&index=0&id=7c7fcc6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7fcc6b",
  null
  
)

component.options.__file = "TvSidePanel.vue"
export default component.exports